<ng-container *transloco="let t; read: 'password'">
  <div class="p-d-flex p-flex-column p-jc-center p-ai-center" style="height: 100vh;">
    <p-card header="{{ t('labels.assessment_runner_administration') }}">

      <p>{{ t('text.please_enter_email') }}</p>

      <p-messages [(value)]="messages"></p-messages>

      <form (ngSubmit)="onSubmit()" novalidate>
        <app-form-control #name [cid]="'email'" [control]="form.get('email')" [type]="'input'" [label]="t('labels.email')"></app-form-control>
        <div class="p-grid">
          <div class="p-col">
            <button pButton type="button" label="{{ t('labels.back_to_login') }}" [routerLink]="['/login']" class="p-button-text"></button>
          </div>
          <div class="p-col p-text-right">
            <button pButton type="submit" label="{{ t('labels.send') }}" [disabled]="busy === true"></button>
          </div>
        </div>
      </form>

    </p-card>
  </div>
</ng-container>
